import DeviceManager from '../utils/device-manager';
import $ from "jquery";
import Flickity from "flickity-fade";
import "flickity-imagesloaded";

class ProductsSlider {
	constructor($el) {
		this.$el = $el;
        this.$wrapper = this.$el.parent();
        this.$buttons = this.$wrapper.find('.slider__button');

		this.options = {
			// autoPlay: true,
			pageDots: false,
			wrapAround: false,
            contain: true,
			prevNextButtons: false,
			freeScroll: true,
			cellSelector: ".product-wrapper",
            cellAlign: "left",
		};

		if (this.$el.length) {
			this._init();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.product-wrapper');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides PRODUITS: ' + this.slidesCount);

        if (document.body.clientWidth < 620 && this.slidesCount > 1) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Products - slider mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 800 && this.slidesCount > 2) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Products - slider tablet');
        } else if (document.body.clientWidth >= 800 && this.slidesCount > 3) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Products - slider desktop SM');
        } else if (document.body.clientWidth >= 1024 && this.slidesCount > 4) {
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('Products - slider desktop MD');
        } else {
            // console.log('Products - no packs slider');
        } 
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);

        this.$buttons.on('click', this._onButtonClick.bind(this));
    }

    _onButtonClick(e) {
        const $target = $(e.currentTarget);

        if($target.hasClass('slider__button--previous')) {
            this.slider.previous(true);
            // console.log('précédent');
        }
        else if($target.hasClass('slider__button--next')) {
            this.slider.next(true);
            // console.log('suivant');
        }
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

	_onBreakpointChange() {
        if (document.body.clientWidth < 620 && this.slidesCount > 1) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 800 && this.slidesCount > 2) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize tablet');
        } else if (document.body.clientWidth >= 800 && this.slidesCount > 3) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize desktop SM');
        } else if (document.body.clientWidth >= 1024 && this.slidesCount > 4) {
            this._destroy();
            this.slider = new Flickity(this.$el[0], this.options);
            // console.log('slider resize desktop MD');
        } else {
            this._destroy();
            // console.log('Products - no products slider');
        }
    }
}

export default ProductsSlider;
